import { Button } from "primereact/button";

export function MentalHealthCarousel(props: any) {
    const handleClick = () => {
        window.open(
            "https://teletechinc.sharepoint.com/teams/Health_and_Wellness/SitePages/Home.aspx",
            "_blank",
            "noreferrer"
        );
    };
    return (
        <div
            className="card border-0 mb-0 pb-0"
            onClick={handleClick}
            style={{ cursor: "pointer" }}
        >
            <img
                src={props.web_url}
                className="w-100 img-fluid desktopImage"
                alt="EmployeeResourceGroups"
            />
            <img
                src={props.mobile_url}
                className="w-100 img-fluid mobileImage"
                alt="EmployeeResourceGroups"
            />
            <div className="card-img-overlay text-start">
                <div className="row mb-4">
                    <div className="col-md-12 pt-3">
                        <>
                            <div className="row position-absolute top-0 start-0 mb-0 me-2 ms-2 mb-md-3 me-md-4 desktopTextWhite">
                                <div className="col-md-12">
                                    <p
                                        className="text-start pe-4"
                                        style={{ color: "black" }}
                                    >
                                        <br />
                                        <strong style={{ fontSize: "large" }}>
                                            {" "}
                                            You matter! It's OK, we're all human!{" "}
                                        </strong>
                                        <br />
                                        <br />
                                        At TTEC, we offer year-round programs dedicated to the
                                        mental
                                        <br /> well-being of our employees.{" "}
                                    </p>
                                </div>
                            </div>
                        </>
                        <Button
                            style={{
                                marginTop: "130px",
                                backgroundColor: "darkblue",
                                textAlign: "left",
                                marginLeft: 0,
                                color: "white",
                            }}
                        >
                            <a
                                href="https://teletechinc.sharepoint.com/teams/Health_and_Wellness/SitePages/Home.aspx"
                                target="_blank"
                                rel="noreferrer"
                                style={{ textDecoration: "none", color: "inherit" }}
                            >
                                Visit Health & Wellness page
                            </a>
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
